












































































































































































































































import { API } from "@/shared/api";
import { ssmHttpService } from "@/shared/services/http-service";
import { JwtService } from "@/shared/services/JwtService";
import { MessageService } from "@/shared/services/message-service";
import usuarioModule from "@/store/modules/usuario-module";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    ChangePwd: () => import("@/views/usuarios/ChangePwd.vue"),
  },
  $_veeValidate: { validator: "new" },
})
export default class MiPerfil extends Vue {
  public shwchangepwd = false;
  public fichero!: File;
  public date = 2;
  public imageError = false;
  public imagePreview = false;
  public loading = false;

  public created() {
    usuarioModule.getmiusuario();
  }

  public get datasource() {
    return usuarioModule.mi_usuario;
  }

  public triggerFileInput() {
    const input = this.$refs.fileInput as any;
    if (input) {
      input.$refs.input.click();
    }
  }

  public previewImage() {
    this.imagePreview = !!this.fichero;
  }

  public cancelar() {
    this.fichero = null as any;
    this.imagePreview = false;
    usuarioModule.getmiusuario();
    MessageService.toast("Cambios cancelados", MessageService.TypeInfo);
  }

  public change_pwd() {
    this.shwchangepwd = true;
  }

  public async aceptar() {
    const allOk = await this.$validator.validateAll();
    if (!allOk) {
      MessageService.toast(
        "Por favor corrige los errores del formulario",
        MessageService.TypeError
      );
      return;
    }

    this.loading = true;
    try {
      await usuarioModule.modificarmi_usuario(this.datasource);

      if (this.fichero) {
        await this.submitFile();
      } else {
        MessageService.toast(
          "Perfil actualizado correctamente",
          MessageService.TypeSuccess
        );
      }
    } catch (error) {
      MessageService.toast(
        "Error al actualizar el perfil",
        MessageService.TypeError
      );
    } finally {
      this.loading = false;
    }
  }

  async submitFile() {
    const formData = new FormData();
    formData.append("file", this.fichero);

    try {
      await ssmHttpService.postfile(API.usuario + "/image", formData);
      MessageService.toast(
        "Perfil e imagen actualizados correctamente",
        MessageService.TypeSuccess
      );
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      MessageService.toast(
        "Error al subir la imagen",
        MessageService.TypeError
      );
    }
  }

  public get getImagen() {
    if (this.imageError) {
      return "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23666' d='M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z' /%3E%3C/svg%3E";
    }
    return (
      API.webApiBaseImages +
      JwtService.jwtDecode().nameid +
      ".png?rnd=" +
      this.date
    );
  }
}
